/**
 * Mixin to support dropdown elements
 */
export default {
  data () {
    return {
      __hitArea: this.$el,
      active: false,
    }
  },

  watch: {
    active (value) {
      const fn = value
        ? document.body.addEventListener
        : document.body.removeEventListener
      fn('mouseup', this.__onClick)
    }
  },

  methods: {
    open () {
      this.active = true
    },

    close () {
      this.active = false
    },

    __onClick(event) {
      const hitArea = this.__hitArea || this.$el
      if (!hitArea.contains(event.target)) {
        this.close()
      }
    },
  }
}
